module.exports = __webpack_public_path__ + "static/media/instrument.f9fc5aa9.svg";